export default "<div id=\"publish-date\"></div>\n";